<template>
  <div class="electronicfence-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" :label-width="formLabelWidth('md')">
        <el-col :span="8">
          <el-form-item :label="$t('operate.name58')" prop="fenceId">
            <el-input v-model="queryInfo.fenceId" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('operate.name59')" prop="fenceName">
            <el-input v-model="queryInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('operate.name60')" prop="fenceType">
            <el-select :key="'fence-type-' + $i18n.locale" v-model="queryInfo.fenceType" :placeholder="$t('public.name1')" style="width:100%">
              <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="bt-layout">
        <el-button type="primary" size="medium" @click="getDataList">{{ $t('public.name3') }}</el-button>
        <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
      </div>
    </div>
    <div>
      <el-button type="primary" size="medium" @click="openFence(null)">{{ $t('operate.name11') }}</el-button>
    </div>
    <el-table :data="tableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column :label="$t('operate.name61')" prop="fenceId" sortable></el-table-column>
      <el-table-column :label="$t('operate.name62')" prop="fenceName" sortable> </el-table-column>
      <!-- <el-table-column label="区域编号" prop="address" sortable></el-table-column>
      <el-table-column label="区域名称" prop="submitterEmail" sortable></el-table-column> -->
      <el-table-column :label="$t('operate.name63')" prop="submitTime" sortable>
        <template slot-scope="scope">
         <div v-if="scope.row.fenceType">{{ ['',$t('operate.name65'),$t('operate.name66'),$t('operate.name126')][scope.row.fenceType] }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('operate.name64')" prop="status" sortable>
        <template>
         <div>{{ $t('operate.name67') }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('manage.name82')" prop="remark" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name9')" width="280px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="openFence(scope.row)">{{ $t('manage.name17') }}</el-button>
          <el-button type="text" @click="editCoordinatePoint(scope.row)">{{ $t('operate.name68') }}</el-button>
          <el-button type="text" @click="delFence(scope.row)">{{ $t('operate.name25') }}</el-button>
          <el-button type="text" @click="showBikeDialog(scope.row)">{{ $t('tabmenu.name8') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="queryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>
    <AppDialog :title="fenceInfo.fenceId ? $t('operate.name70') : $t('operate.name69')" :visible.sync="fenceDialog" v-if="fenceDialog" width="400px" :before-close="handleClose">
      <el-form ref="fenceFormRef" :model="fenceInfo" size="medium" :label-width="formLabelWidth('md2')" :rules="fenceInfoRules">
          <el-form-item :label="$t('operate.name59')" prop="fenceName">
            <el-input v-model="fenceInfo.fenceName" :placeholder="$t('public.name5')" clearable> </el-input>
            <!-- <el-select v-model="fenceInfo.fenceName" :placeholder="$t('operate.name1')" style="width:100%">
              <el-option
              v-for="item in fenceOptions"
              :key="item.fenceId"
              :label="item.fenceName"
              :value="item.fenceId">
            </el-option>
          </el-select> -->
          </el-form-item>
          <el-form-item :label="$t('operate.name60')" prop="fenceType">
            <el-select :key="'fence-info-type-' + $i18n.locale" v-model="fenceInfo.fenceType" :placeholder="$t('public.name1')" style="width:100%" clearable>
              <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item :label="$t('operate.name71')" prop="draw">
            <el-select :key="'fence-draw-' + $i18n.locale" v-model="fenceInfo.draw" :placeholder="$t('public.name1')" style="width:100%" clearable>
              <el-option
              v-for="item in drawOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          </el-form-item>
          <el-form-item :label="$t('manage.name78')" prop="remark">
            <el-input
            clearable
            type="textarea"
            :rows="2"
           :placeholder="$t('public.name5')"
            v-model="fenceInfo.remark">
          </el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
    <AppDialog :title="$t('operate.name79')" :visible.sync="bikeListDialog" v-if="bikeListDialog" width="600px" :before-close="handleClose">
      <el-form ref="fenceFormRef" :model="bikeQueryInfo" size="medium" :label-width="formLabelWidth('md')" :inline="true">
          <el-form-item :label="$t('bike.name98')" prop="ebikeId">
            <el-input
            clearable
            :placeholder="$t('public.name5')"
            v-model="bikeQueryInfo.ebikeId">
          </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button  type="primary" size="small" @click="getFindFenceEbikePage">{{ $t('operate.name80') }}</el-button>
            <el-button  type="primary" size="small" @click="addIOT">{{ $t('operate.name11') }}</el-button>
            <el-button  type="primary" size="small" @click="importIOT">{{ $t('operate.name81') }}</el-button>
          </el-form-item>
      </el-form>
      <el-table :data="bikeTableList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading1">
      <el-table-column :label="$t('bike.name29')" prop="createTime" sortable>
        <template slot-scope="scope">
          {{ scope.row.createTime | tzDisplay }}
        </template>
      </el-table-column>
      <el-table-column :label="$t('bike.name41')" prop="ebikeId" sortable> </el-table-column>
      <el-table-column :label="$t('operate.name9')" width="80px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="delBike(scope.row)">{{ $t('operate.name25') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleBikeSizeChange"
      @current-change="handleBikeCurrentChange"
      :current-page="bikeQueryInfo.pageNumber"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="bikeQueryInfo.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="bikeTotal"
    >
    </el-pagination>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose1">{{ $t('public.name14') }}</el-button>
      </span> -->
    </AppDialog>
    <AppDialog :title="$t('operate.name82')" :visible.sync="iotDialog" v-if="iotDialog" width="400px" :before-close="handleClose2">
      <el-form ref="iotFormRef" :model="bikeInfo" size="medium" :label-width="formLabelWidth('md')" :inline="true" :rules="iotRules">
          <el-form-item :label="$t('bike.name98')" prop="eBikeId">
            <el-select v-model="bikeInfo.ebikeId" filterable clearable :placeholder="$t('public.name1')">
              <el-option
              v-for="item in iotList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>
          </el-select>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitIotForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose2">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
    <AppDialog :title="$t('operate.name83')" :visible.sync="iotImportDialog" v-if="iotImportDialog" width="600px" :before-close="handleClose3">
      <el-form ref="iotImportFormRef" :label-width="formLabelWidth('lg2')">
        <el-form-item :label="$t('bike.name100')">
          <a href="https://listek.oss-cn-hangzhou.aliyuncs.com/dev/1/1864144/导入电子围栏车辆列表.xlsx">
            <el-button type="primary">{{ $t('bike.name101') }}</el-button>
          </a>
        </el-form-item>
        <el-form-item :label="$t('bike.name102')" prop="fiveWayCodeFile" style="width:100%;">
          <el-button type="primary" @click="handleManualUpload">{{ $t('bike.name103') }}</el-button>
          <input type="file" style="display: none" ref="fileInput" @change="handleFileChange">
          <el-upload
          ref="upload"
          action=""
          :limit="1"
          :before-upload="handleBeforeUpload">
        </el-upload>

         <div class="file-list" v-if="fiveWayCodeFile">
          <div>{{ fiveWayCodeFile.name }}</div>
          <div><i class="el-icon-close" @click="delFile"></i></div>
         </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="uploadSectionFile" :loading='loading'>{{ $t('public.name13') }}</el-button>
        <el-button @click="handleClose3">{{ $t('public.name14') }}</el-button>
      </span>
    </AppDialog>
    <AppDialog size="lg" width="80%" extra-class="el-dialog--responsive" :title="$t('screen.name167')" :visible.sync="distributionFenceDialog" v-if="distributionFenceDialog" :before-close="handleClose4">
    <SharRregion :fence-id="findFenceDetail.fenceId" />
    </AppDialog>
  </div>
</template>
<script>
import { findFencePage, addFence, modifyFence, removeFence, findFenceList, findFenceEbikePage, removeFenceEbike, importFenceEbike, listNotInEbikeId, addFenceEbike } from '@/api/operate.js'
import { mapGetters } from 'vuex'
import { downloadExcel } from '@/utils/utils'
import SharRregion from './SharRregion.vue'
import AppDialog from '@/components/AppDialog/index.vue'
export default {
  computed: {
    ...mapGetters(['userinfo']),
    typeOptions () {
      return [
        { label: this.$t('operate.name65'), value: 1 },
        { label: this.$t('operate.name66'), value: 2 },
        { label: this.$t('operate.name126'), value: 3 }
      ]
    },
    drawOptions () {
      return [
        { label: this.$t('operate.name67'), value: 1 }
      ]
    }
  },
  data() {
    return {
      queryInfo: {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        pageSize: 10,
        pageNumber: 1
      },
      findFenceDetail: {
        fenceId: ''
      },
      fenceDialog: false,
      distributionFenceDialog: false,
      bikeListDialog: false,
      iotDialog: false,
      iotImportDialog: false,
      tableLoading: false,
      bikeTableList: [],
      loading: false,
      tableLoading1: false,
      tableList: [],
      total: 0,
      fenceOptions: [],
      fenceInfo: {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        draw: '',
        remark: '',
        fencePointList: []
      },
      fenceInfoRules: {
        area: [
          {
            required: true,
            message: this.$t('operate.name171'),
            trigger: 'blur'
          }
        ],
        fenceName: [
          {
            required: true,
            message: this.$t('operate.name172'),
            trigger: 'blur'
          }
        ],
        fenceType: [
          {
            required: true,
            message: this.$t('operate.name173'),
            trigger: 'blur'
          }
        ],
        draw: [
          {
            required: true,
            message: this.$t('operate.name174'),
            trigger: 'blur'
          }
        ]
      },
      bikeQueryInfo: {
        ebikeId: '',
        fenceId: '',
        pageSize: 10,
        pageNumber: 1
      },
      iotRules: {
        ebikeId: [
          {
            required: true,
            message: this.$t('operate.name175'),
            trigger: 'blur'
          }
        ]
      },
      bikeTotal: 0,
      iotList: [],
      bikeInfo: {
        ebikeId: '',
        fenceId: ''
      },
      fiveWayCodeFile: null
    }
  },
  components: {
    SharRregion,
    AppDialog
  },
  created() {
    // console.log('userinfo===', this.userinfo)
  },
  mounted() {
    this.getFindFenceList()
    this.queryList()
  },
  methods: {
    openFence(row) {
      this.fenceDialog = true
      if (row) {
        this.fenceInfo.fenceId = row.fenceId
        this.fenceInfo.fenceName = row.fenceName
        this.fenceInfo.fenceType = row.fenceType
        this.fenceInfo.draw = 1
        this.fenceInfo.remark = row.remark
        this.fenceInfo.fencePointList = row.fencePointList
      }
    },
    getFindFenceList() {
      findFenceList({})
        .then(res => {
          this.fenceOptions = res.data.fenceList
        })
        .catch(() => {
        })
    },
    getDataList() {
      this.queryInfo.pageNumber = 1
      this.queryInfo.pageSize = 10
      this.queryList()
    },
    queryList() {
      this.tableLoading = true
      findFencePage(this.queryInfo)
        .then(res => {
          this.tableList = res.data.fencePage.records
          this.total = res.data.fencePage.total
          this.tableLoading = false
        })
        .catch(() => {
          this.tableList = []
          this.total = 0
          this.tableLoading = false
        })
    },
    resetQuery() {
      this.queryInfo = {
        fenceId: '',
        fenceName: '',
        fenceType: '',
        pageSize: 10,
        pageNumber: 1
      }
      this.queryList()
    },
    submitForm() {
      this.$refs.fenceFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        this.fenceOptions.forEach((item) => {
          if (this.fenceInfo.fenceName === item.fenceId) {
            this.fenceInfo.fenceName = item.fenceName
            this.fenceInfo.fencePointList = item.fencePointList
            return false
          }
        })
        if (this.fenceInfo.fenceId === '') {
          addFence(this.fenceInfo).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.handleClose()
              this.queryList()
            }
          }).catch(() => {
            this.loading = false
          })
        } else {
          modifyFence(this.fenceInfo).then(res => {
            this.loading = false
            if (res.code === 200) {
              this.handleClose()
              this.queryList()
            }
          }).catch(() => {
            this.loading = false
          })
        }
      })
    },
    handleClose() {
      this.fenceDialog = false
      this.bikeListDialog = false
      this.fenceInfo = {
        fenceId: '',
        fencePointList: [],
        fenceName: '',
        fenceType: '',
        draw: '',
        remark: ''
      }
    },
    handleClose1() {
      this.bikeListDialog = false
    },
    handleClose2() {
      this.iotDialog = false
      this.bikeInfo.ebikeId = ''
    },
    addIOT() {
      this.iotDialog = true
      listNotInEbikeId().then(res => {
        if (res.code === 200) {
          this.iotList = res.data.notInEbikeIdList
        }
      }).catch(() => {})
    },
    submitIotForm() {
      this.$refs.iotFormRef.validate(async valid => {
        if (!valid) return
        this.loading = true
        addFenceEbike(this.bikeInfo).then(res => {
          if (res.code === 200) {
            this.bikeQueryInfo.pageNumber = 1
            this.bikeQueryInfo.pageSize = 10
            this.queryBikeList()
            this.handleClose2()
          }
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      })
    },
    delFence(row) {
      this.$confirm(this.$t('public.name24'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      }).then(() => {
        removeFence({ fenceId: row.fenceId }).then(res => {
          if (res.code === 200) {
            this.queryList()
          }
        }).catch(() => {})
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('public.name31')
        })
      })
    },
    showBikeDialog(row) {
      this.bikeListDialog = true
      this.bikeQueryInfo.fenceId = row.fenceId
      this.bikeQueryInfo.pageNumber = 1
      this.bikeQueryInfo.pageSize = 10
      this.bikeInfo.fenceId = row.fenceId
      this.queryBikeList()
    },
    queryBikeList() {
      this.tableLoading1 = true
      this.bikeQueryInfo.ebikeId = (this.bikeQueryInfo.ebikeId || '').trim()
      findFenceEbikePage(this.bikeQueryInfo).then(res => {
        this.bikeTableList = res.data.fenceEbikePage.records
        this.bikeTotal = res.data.fenceEbikePage.total
        this.tableLoading1 = false
      }).catch(() => {
        this.bikeTableList = []
        this.bikeTotal = 0
        this.tableLoading1 = false
      })
    },
    getFindFenceEbikePage() {
      this.queryBikeList()
    },
    delBike(row) {
      this.$confirm(this.$t('public.name52'), this.$t('public.name23'), {
        confirmButtonText: this.$t('public.name25'),
        cancelButtonText: this.$t('public.name14'),
        type: 'warning'
      }).then(() => {
        removeFenceEbike({ fenceEbikeId: row.fenceEbikeId }).then(res => {
          if (res.code === 200) {
            this.bikeQueryInfo.pageNumber = 1
            this.bikeQueryInfo.pageSize = 10
            this.queryBikeList()
          }
        }).catch(() => {})
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('public.name31')
        })
      })
    },
    importIOT() {
      this.iotImportDialog = true
    },
    handleBeforeUpload(file) {
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error(this.$t('public.name36'))
        return false
      }
      return true
    },
    handleFileChange(e) {
      this.fiveWayCodeFile = e.target.files[0]
      e.target.value = ''
    },
    delFile() {
      this.fiveWayCodeFile = null
    },
    handleManualUpload() {
      this.$refs.fileInput.click()
    },
    uploadSectionFile() {
      if (this.fiveWayCodeFile === null) {
        return
      }
      const formData = new FormData()
      formData.append('file', this.fiveWayCodeFile)
      formData.append('fenceId', this.bikeQueryInfo.fenceId)
      this.loading = true
      importFenceEbike(formData)
        .then(res => {
          this.loading = false
          downloadExcel(res, this.$t('public.name53'), 'xlsx', true)
          this.bikeQueryInfo.pageNumber = 1
          this.bikeQueryInfo.pageSize = 10
          this.getFindFenceEbikePage()
          this.handleClose3()
        })
        .catch(res => {
          this.loading = false
        })
    },
    editCoordinatePoint(row) {
      this.findFenceDetail.fenceId = row.fenceId
      this.distributionFenceDialog = true
    },
    handleClose4() {
      this.distributionFenceDialog = false
    },
    handleClose3() {
      this.iotImportDialog = false
      this.fiveWayCodeFile = null
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize
      this.queryList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.pageNumber = newPage
      this.queryList()
    },
    handleBikeSizeChange(newSize) {
      this.bikeQueryInfo.pageSize = newSize
      this.queryBikeList()
    },
    handleBikeCurrentChange(newPage) {
      this.bikeQueryInfo.pageNumber = newPage
      this.queryBikeList()
    }
  }
}
</script>
<style lang="scss" scoped>
.electronicfence-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  .search-layout {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .bt-layout {
    display: flex;
    flex-direction: row;
    height: 36px;
  }
  .margin10 {
    padding-left: 10px;
  }
  .file-list{
    width: 70%;
    display: flex;
    justify-content: space-between;
    margin-top: -25px;

    .el-icon-close{
      font-size: 18px;
    }
  }
}
</style>
